export default "__VITE_PUBLIC_ASSET__dd36a9a4__"